
import { Trek, Company, TrekPackage } from '../types/trek-types';
import { ApiFactory } from '@/api/api-factory';

/**
 * Get all treks
 */
export const getAllTreks = async (): Promise<Trek[]> => {
  try {
    const result = await ApiFactory.getClient().getAllTreks();
    return result;
  } catch (error) {
    console.error('Error fetching all treks:', error);
    return [];
  }
};

/**
 * Get a specific trek by ID
 */
export const getTrekById = async (id: string): Promise<Trek | null> => {
  try {
    const result = await ApiFactory.getClient().getTrekById(id);
    return result;
  } catch (error) {
    console.error('Error fetching trek by ID:', error);
    return null;
  }
};

/**
 * Get similar treks based on a trek ID
 */
export const getSimilarTreks = async (trekId: string, limit = 3): Promise<Trek[]> => {
  try {
    const result = await ApiFactory.getClient().getSimilarTreks(trekId, limit);
    return result;
  } catch (error) {
    console.error('Error fetching similar treks:', error);
    return [];
  }
};

/**
 * Get a specific company by ID
 */
export const getCompanyById = async (id: string): Promise<Company | null> => {
  try {
    const result = await ApiFactory.getClient().getCompanyById(id);
    return result;
  } catch (error) {
    console.error('Error fetching company by ID:', error);
    return null;
  }
};

/**
 * Get all companies
 */
export const getAllCompanies = async (): Promise<Company[]> => {
  try {
    const result = await ApiFactory.getClient().getAllCompanies();
    return result;
  } catch (error) {
    console.error('Error fetching all companies:', error);
    return [];
  }
};

/**
 * Get packages for a specific trek
 */
export const getPackagesByTrekId = async (trekId: string): Promise<TrekPackage[]> => {
  try {
    const result = await ApiFactory.getClient().getPackagesByTrekId(trekId);
    return result;
  } catch (error) {
    console.error('Error fetching packages by trek ID:', error);
    return [];
  }
};

/**
 * Get packages for a specific company
 */
export const getPackagesByCompanyId = async (companyId: string): Promise<TrekPackage[]> => {
  try {
    const result = await ApiFactory.getClient().getPackagesByCompanyId(companyId);
    return result;
  } catch (error) {
    console.error('Error fetching packages by company ID:', error);
    return [];
  }
};

/**
 * Get a specific package by ID
 */
export const getPackageById = async (packageId: string): Promise<TrekPackage | null> => {
  try {
    const result = await ApiFactory.getClient().getPackageById(packageId);
    return result;
  } catch (error) {
    console.error('Error fetching package by ID:', error);
    return null;
  }
};
